import es from "../data/locales/es.json";

/**
 * Human-readable label for an AccionSistema / audit `tipo` code (Spanish UI strings from locale).
 * @param {string | null | undefined} tipo
 * @returns {string}
 */
export function getAccionSistemaTipoLabel(tipo) {
  const raw = typeof tipo === "string" ? tipo.trim() : "";
  if (raw === "") {
    return "";
  }
  const labels = es.activityLog?.tipoLabels;
  if (labels != null && typeof labels === "object" && !Array.isArray(labels)) {
    const label = /** @type {Record<string, unknown>} */ (labels)[raw];
    if (typeof label === "string" && label.trim() !== "") {
      return label;
    }
  }
  return raw;
}
